<template>
<div class="pageMessage">
    <div class="list messageInfo">
        <div class="item" v-if="info">
            <div class="title">{{ info.title }}</div>
            <div class="time">{{ info.created_at }}</div>
            <div class="info" v-html="info.content"></div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			publicPath: process.env.BASE_URL,
			token: this.$store.getters.token,
			id: this.$route.query.id, // 消息id
            info: null, // 消息详情
            token: null
        };
    },
    created: function () {
        
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '消息详情',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            var memberParams = {
                data: {
                },
            }
            //加载用户信息
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
				token: this.token,
				id: this.id
			}
			this.$api.xiaoxi.msgDetail(params).then(res=>{
				if(res.code == 200) {
					this.info = res.result
				}
			})
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
